module.exports = __webpack_public_path__ + "assets/img/hmid.de24a041.png";